import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { Subscription } from "../../interfaces/rbac";
import { useCreateWorkspace, useSubscriptions } from "../Rbac/RbacQueries";
import { DialogProps } from "./useDialogs";

function CreateWorkspaceDialog({ open, onClose }: DialogProps) {
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const { mutate: createWorkspaceMutate } = useCreateWorkspace();
  const { data: subscriptions, isLoading } = useSubscriptions();

  const handleCreate = () => {
    createWorkspaceMutate({
      name,
      description,
      subscription: subscription?._id ?? "",
    });
    onClose();
    setName("");
    setDescription("");
    setSubscription(null);
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Créer un espace de travail</DialogTitle>
      <DialogContent>
        <TextField
          size="small"
          label="Nom"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ my: 2 }}
        />
        <TextField
          size="small"
          label="Description"
          multiline
          rows={4}
          fullWidth
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Autocomplete
          disablePortal
          size="small"
          fullWidth
          value={subscription}
          onChange={(e, value) => setSubscription(value ?? null)}
          options={subscriptions ?? []}
          renderInput={(params) => <TextField {...params} label="Abonnement" />}
          getOptionLabel={(option) => option.type}
          loading={isLoading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button onClick={handleCreate} variant="contained">
          Créer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateWorkspaceDialog;
